import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

export default function AdminOverviewPage({ analytics, userActivity }) {
  const topUsers = [...userActivity]
    .sort((a, b) => (b.login_count || 0) - (a.login_count || 0))
    .slice(0, 8)
    .map((user) => ({
      name: user.name?.split(" ")[0] || user.email,
      logins: user.login_count || 0,
    }));

  const formatLastSeen = (value) => {
    if (!value) return "Never";
    try {
      return new Date(value).toLocaleString();
    } catch {
      return "Unknown";
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
        <Card className="shadow-lg border-l-4 border-l-indigo-500">
          <CardContent className="pt-4">
            <p className="text-sm text-slate-500">Total Coaches</p>
            <p className="text-3xl font-bold text-slate-900">{analytics?.total_coaches ?? "-"}</p>
          </CardContent>
        </Card>
        <Card className="shadow-lg border-l-4 border-l-sky-500">
          <CardContent className="pt-4">
            <p className="text-sm text-slate-500">Total Parents</p>
            <p className="text-3xl font-bold text-slate-900">{analytics?.total_parents ?? "-"}</p>
          </CardContent>
        </Card>
        <Card className="shadow-lg border-l-4 border-l-emerald-500">
          <CardContent className="pt-4">
            <p className="text-sm text-slate-500">Active Users (7d)</p>
            <p className="text-3xl font-bold text-slate-900">{analytics?.active_users_7d ?? "-"}</p>
          </CardContent>
        </Card>
        <Card className="shadow-lg border-l-4 border-l-amber-500">
          <CardContent className="pt-4">
            <p className="text-sm text-slate-500">Total Logins</p>
            <p className="text-3xl font-bold text-slate-900">{analytics?.total_logins ?? "-"}</p>
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        <Card className="shadow-lg xl:col-span-2">
          <CardHeader className="border-b">
            <CardTitle className="text-lg">Top User Logins</CardTitle>
          </CardHeader>
          <CardContent className="pt-4 h-[300px]">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={topUsers} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="name" />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="logins" fill="#0F172A" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>

        <Card className="shadow-lg">
          <CardHeader className="border-b">
            <CardTitle className="text-lg">Recent Access</CardTitle>
          </CardHeader>
          <CardContent className="pt-3 space-y-3 max-h-[300px] overflow-y-auto">
            {userActivity.slice(0, 8).map((user) => (
              <div key={user.id} className="rounded-lg border border-slate-200 p-3 bg-white">
                <p className="font-medium text-slate-900">{user.name}</p>
                <p className="text-xs text-slate-500">{user.email}</p>
                <div className="mt-2 flex items-center justify-between text-xs">
                  <span className="text-slate-600">Logins: {user.login_count || 0}</span>
                  <span className="text-slate-500">{formatLastSeen(user.last_login_at)}</span>
                </div>
              </div>
            ))}
            {userActivity.length === 0 && <p className="text-sm text-slate-500">No activity yet</p>}
          </CardContent>
        </Card>
      </div>
    </>
  );
}
